import React from 'react';

import { useSelector/* , useDispatch */ } from 'react-redux';

import DialogPortal from "Components/DialogPortal";


const Toast = () => {
  const currentToast = useSelector(state => state.base.toast.current);

  return (
    <>
      {
        currentToast ? (
          <DialogPortal>
            <div className="toastPop">
              <div className="message">{currentToast}</div>
            </div>
          </DialogPortal>
        ) : null
      }
    </>
  )
}

export default Toast;